module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce-img-3.e5bf1198.webp";